import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import ReviewsTable from "components/Doobi/Reviews";

const ReviewsRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Reviews" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={ReviewsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default ReviewsRoute;
